import { useQuasar } from 'quasar'
import { useI18n } from 'vue-i18n'

const useNotifyMessage = () => {
  const $q = useQuasar()
  const { t } = useI18n()

  const notifyMessage = (type = 'info', message = 'info', position = 'center', timeout = 3000) => {
    const { background, iconColorBg, iconType } = backgroundIconColor(type)
    $q.notify({
      type,
      message: t(message),
      position,
      timeout,
      color: background,
      textColor: 'primary',
      icon: iconType,
      iconColor: iconColorBg,
      progress: true,
      multiLine: true
    })
  }

  const backgroundIconColor = (type) => {
    let data = {
      background: null,
      iconColorBg: null,
      iconType: null
    }

    if (type === 'error') {
      data.background = 'red-1'
      data.iconColorBg = 'red-5'
      data.iconType = 'mdi-close-octagon'
    } else if (type === 'success') {
      data.background = 'green-1'
      data.iconColorBg = 'green-5'
      data.iconType = 'mdi-check-circle'
    } else if (type === 'warning') {
      data.background = 'yellow-1'
      data.iconColorBg = 'yellow-7'
      data.iconType = 'mdi-alert'
    } else {
      data.background = 'blue-1'
      data.iconColorBg = 'blue-5'
      data.iconType = 'mdi-information'
    }

    return data
  }

  return {
    notifyMessage
  }

}

export default useNotifyMessage